module.exports = __webpack_public_path__ + "39e23c6ba6e51f48d4e1a3f6a837f707.jpg";


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/pic3.jpg
// module id = 273
// module chunks = 0